<script lang="ts">
import { tv } from 'tailwind-variants';
import MonospaceLogo from '#layers/ui/assets/monospace-logo-color.svg';

export type LogoSize = 'xs' | 'sm' | 'md' | 'lg';

export const logoSizes: Record<LogoSize, string> = {
	xs: 'size-5',
	sm: 'size-9',
	md: 'size-12',
	lg: 'size-20',
};

// Corner radius scales with size so the logo reads as the same shape at every scale.
export const logoRadii: Record<LogoSize, string> = {
	xs: 'rounded-sm',
	sm: 'rounded-md',
	md: 'rounded-md',
	lg: 'rounded-md',
};

export interface DynamicLogoProps {
	size?: LogoSize;
	icon?: string;
}

const containerTv = tv({
	base: 'flex items-center justify-center overflow-hidden',
	variants: {
		size: logoSizes,
		radius: logoRadii,
	},
	defaultVariants: {
		size: 'sm',
		radius: 'sm',
	},
});

const iconTv = tv({
	base: 'text-muted',
	variants: {
		size: {
			xs: 'size-3',
			sm: 'size-5',
			md: 'size-5',
			lg: 'size-6',
		},
	},
	defaultVariants: {
		size: 'sm',
	},
});
</script>

<script setup lang="ts">
import { computed } from 'vue';

const { size = 'sm' } = defineProps<DynamicLogoProps>();

const containerClass = computed(() => containerTv({ size, radius: size }));
const iconClass = computed(() => iconTv({ size }));
</script>

<template>
	<div class="text-(--brand-color,var(--color-primary))" :class="[containerClass]">
		<slot>
			<DIcon
				v-if="icon"
				:name="icon"

				:class="iconClass"
			/>
			<MonospaceLogo
				v-else

				class="size-full object-contain"
			/>
		</slot>
	</div>
</template>
